import React from "react";
import { Link } from "react-router-dom";

const MyHeader = () => {
  return (
    <footer className="header">
      <nav className="headerLinks">
        <Link className="footerLink" to="/imprint">
          Imprint
        </Link>
        <Link className="footerLink" to="/privacy">
          Privacy
        </Link>
      </nav>
      {/* the name leads back home */}
      <Link className="footerLink copyrightNotice" to="/">
        © {new Date().getFullYear()} Matteo Rosoli
      </Link>
    </footer>
  );
};

export default MyHeader;
